<template>
  <div class="edit-input">
    <span class="edit-input__label font-labelheavy">{{ label }}</span>

    <!-- 下拉框 -->
    <el-select
      v-if="type === 'select'"
      v-model="modelValue"
      @change="handleSelectChange"
      class="edit-input__content font-labelheavy"
      popper-class="edit-select"
      :class="{ readonly: visibleReadonly }"
      :filterable="filterable"
      :remote="remote"
      :placeholder="placeholder"
      :loading="loading"
      :remote-method="remoteMethod"
    >
      <el-option
        v-for="item in selectList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <!-- 纯输入框 -->
    <el-input
      v-else
      v-model="modelValue"
      :autosize="autosize"
      :rows="rows"
      :type="type"
      :readonly="visibleReadonly"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :show-word-limit="showWordLimit"
      :class="{ readonly: visibleReadonly }"
      class="edit-input__content font-labelheavy"
    />

    <!-- slot:append -->
    <slot name="append"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { modelMixin } from '../../assets/js/mixins/model';

export default {
  name: 'EditInput',

  props: {
    rows: {
      type: Number,
      default: 1
    },
    label: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    },
    filterable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    remoteMethod: {
      type: Function
    },
    maxlength: {
      type: Number,
      default: 100000
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    autosize: {
      default: true
    }
  },

  mixins: [modelMixin],

  computed: {
    ...mapGetters('report', ['assignList']),
    type() {
      return this.options.type || 'text';
    },
    selectList() {
      return this.options.list || this.assignList || [];
    },
    visibleReadonly() {
      return !this.edit || this.readonly;
    }
  },
  methods: {
    handleSelectChange(va) {}
  }
};
</script>

<style lang="scss">
.edit-input {
  display: flex;
  margin-top: 6px;
  align-items: flex-start;
  &__label {
    line-height: 28px;
    color: #888;
    white-space: nowrap;
  }
  &__content {
    margin-left: 34px;
    width: 287px;
    &.readonly {
      &.el-select {
        pointer-events: none;
      }
      .el-input,
      .el-textarea {
        &__inner {
          box-shadow: unset;
          cursor: text;
        }
        &__suffix {
          display: none;
        }
      }
      .el-textarea__inner {
        line-height: 28px;
      }
    }
    .el-input,
    .el-textarea {
      &__inner {
        padding: 0 3px;
        height: 28px;
        font-size: 13px;
        line-height: 28px;
        resize: none;
        border-radius: unset;
        border: 0;
        box-shadow: inset 0px 0px 3px 0px rgba(2, 125, 180, 0.7);
      }
      &__suffix {
        &-inner {
          display: flex;
          align-items: center;
          height: 100%;
        }
      }
    }
    .el-textarea__inner {
      line-height: 18px;
    }
    .el-select {
      &__caret {
        color: #000 !important;
        font-weight: bold;
        font-size: 12px !important;
        line-height: 1;
      }
    }
  }
}
.edit-select {
  .el-select-dropdown {
    &__item {
      height: 20px;
      line-height: 20px;
      font-size: 13px;
      font-family: 'Arial Negreta';
    }
  }
}
</style>
